import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import ConceptsPreview from '../components/ConceptsPreview';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Hero />
      <About />
      <ConceptsPreview />
    </div>
  );
};

export default Home;
